export const productShortName = 'Industria del Petrolio e del Gas — Edizione Docenti';
export const productBrand = 'Industria del Petrolio e del Gas';
export const productEdition = 'Edizione Docenti';
export const productImage = 'https://cdn.magicpatterns.com/uploads/wLwbawWDEsgaMfBFye48VT/MOCKUP_PETROLIO.png';
export const productImageAlt =
  'Industria del Petrolio e del Gas Edizione Docenti: collezione didattica in 6 volumi con 5 risorse bonus, circondata da piattaforma offshore, raffineria, barile e oleodotto';

export const checkoutUrl = 'https://petrolio-gas-docenti.impultienda.ar/checkout';

export const price = '€27';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta preparare ogni lezione su petrolio e gas da zero',
  'Basta spiegare giacimenti, perforazione e raffinazione senza materiali chiari',
  'Basta ore perse a cercare schemi e dati affidabili su internet',
  "Basta verifiche improvvisate all'ultimo minuto",
  'Basta studenti che non collegano il petrolio alla vita quotidiana',
];
